import ZoomInIcon from "@/assets/ZoomInIcon";
import ZoomOutIcon from "@/assets/ZoomOutIcon";
import useMapMode from "@/services/store/useMapMode";
import { MAP_MODES } from "@/utils/constants/modes";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import { Box, IconButton, Popper, Stack, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useMap } from "react-leaflet";

// has to be inside of Leaflet MapContainer to work properly !
const BottomLeftPanel = () => {
  const map = useMap();

  const setMode = useMapMode((state) => state.setMode);

  const [layersAnchorEl, setLayersAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleLayerClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setLayersAnchorEl((prev) => (prev ? null : (e.target as HTMLButtonElement)));
  };

  const handleZoomIn = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    map.setZoom(map.getZoom() + 1);
  };

  const handleZoomOut = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    map.setZoom(map.getZoom() - 1);
  };

  const handleModeClick = (mode: MapMode) => (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    setMode(mode);
    setLayersAnchorEl(null);
  };

  return (
    <Box
      sx={{
        position: "absolute",
        zIndex: 600,
        bottom: 15,
        width: 35,
        left: 10,
      }}>
      <Stack
        divider={
          <Box
            sx={{ height: "1px", width: "100%", background: (theme: ThemeType) => theme.palette.primary.contrastText }}
          />
        }
        sx={{
          background: (theme: ThemeType) => theme.palette.secondary.main,
          borderRadius: 4,
        }}
        spacing={0.5}>
        <IconButton onMouseDown={handleZoomIn}>
          <ZoomInIcon color="white" />
        </IconButton>
        <IconButton onMouseDown={handleZoomOut}>
          <ZoomOutIcon color="white" />
        </IconButton>
        <IconButton onMouseDown={handleLayerClick}>
          <AddRoadIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
        </IconButton>
      </Stack>
      <Popper open={Boolean(layersAnchorEl)} anchorEl={layersAnchorEl} placement="right">
        <Box
          sx={{
            background: (theme: ThemeType) => theme.palette.secondary.main,
            borderRadius: 2,
            padding: "0px 8px",
            ml: 1,
          }}>
          <Stack direction="row">
            {MAP_MODES.map((mapMode) => (
              <Tooltip key={mapMode.name} title={mapMode.name}>
                <IconButton onClick={handleModeClick(mapMode.mode as MapMode)}>{mapMode.icon}</IconButton>
              </Tooltip>
            ))}
          </Stack>
        </Box>
      </Popper>
    </Box>
  );
};

export default BottomLeftPanel;
